export const fromCents = (cents: number) => {
  return cents / 100;
};
